import Immutable from 'immutable';

const SimCardAlertConditionModel = Immutable.Record({
	field: '',
	value: null,
	inverted: false
});

export default class SimCardAlertCondition extends SimCardAlertConditionModel {
	
	field: string;
	value: any;
	inverted: boolean;
	
	summary(fields) {
		const field = fields.find(f => f.value === this.get('field'));
		if(!field) return '';
		const value = this.get('value')
		if(Array.isArray(value)) {
			if(value.length === 1) {
				return `${value.length} ${field.label.lc()}`;
			} else {
				return `${value.length} ${field.plural.lc()}`;
			}
		}
		return value;
	}
	
	get canSave() {
		if(!this.get('field')) return false;
		const value = this.get('value')
		if(Array.isArray(value)) return !!value.length;
		return !!value;
	}
}
